// 흘러내리는 물줄기 셰이더: 라군 헹굼 폭포와 찜질방 샤워가 같이 쓴다 (프로토타입 rinseMat 2197). uT는 방의 tick이 올린다.
import * as THREE from 'three';

export const rinseMat = new THREE.ShaderMaterial({
  transparent: true, depthWrite: false, side: THREE.DoubleSide, uniforms: { uT: { value: 0 } },
  vertexShader: 'varying vec2 vUv; void main(){ vUv = uv; gl_Position = projectionMatrix*modelViewMatrix*vec4(position, 1.0); }',
  fragmentShader: [
    'varying vec2 vUv; uniform float uT; float h(float x){ return fract(sin(x*127.1)*43758.5); }',
    'void main(){ float col = floor(vUv.x*10.0); float y = fract(vUv.y*2.0 + uT*(1.6 + h(col)*0.8) + h(col + 3.0));',
    '  float streak = 0.5 + 0.5*smoothstep(0.0, 0.3, y)*smoothstep(1.0, 0.55, y);',
    '  gl_FragColor = vec4(mix(vec3(0.82, 0.95, 1.0), vec3(1.0), streak), 0.45 + 0.4*streak); }',
  ].join('\n'),
});
